// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-icon {
  color: #ed143d;
  font-size: 20px !important;
  margin-right: 10px;
}

ion-select::part(label) {
  color: #888;
  font-size: 17px;
}

ion-select::part(container) {
  font-size: 15px;
}

ion-select::part(icon) {
  color: #ed143d;
  transform: translateY(10px);
}

.settings-section {
  background-color: #efefef;
  border-radius: 8px;
  margin: 10px 0;
  padding: 0 4px 0 8px;
}

ion-select {
  transform: translateY(-4px);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/language-switch/language-switch.component.scss"],"names":[],"mappings":"AAUA;EACI,cAAA;EACA,0BAAA;EACA,kBAAA;AATJ;;AAWE;EACE,WAAA;EACA,eAAA;AARJ;;AAWE;EACE,eAAA;AARJ;;AAWE;EACE,cAAA;EACA,2BAAA;AARJ;;AAWE;EACE,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,oBAAA;AARJ;;AAUE;EACE,2BAAA;AAPJ","sourcesContent":["// ion-select::part(icon) {\n//     display: none;\n// }\n\n// ion-icon {\n//     font-size: 32px;\n//     margin-right: 10px;\n// }\n\n\nion-icon {\n    color:#ed143d;\n    font-size: 20px !important;\n    margin-right: 10px;\n  }\n  ion-select::part(label) {\n    color: #888;\n    font-size: 17px;\n  }\n  \n  ion-select::part(container) {\n    font-size: 15px;\n  }\n  \n  ion-select::part(icon) {\n    color: #ed143d;\n    transform: translateY(10px);\n  }\n  \n  .settings-section {\n    background-color: #efefef;\n    border-radius: 8px;\n    margin: 10px 0;\n    padding: 0 4px 0 8px;\n  }\n  ion-select {\n    transform: translateY(-4px);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
